/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeBotChatLogResponse,
  ApiEnvelopeBotCommandResponse,
  ApiEnvelopeBotConsoleLogResponse,
  ApiEnvelopeBotEntitiesResponse,
  ApiEnvelopeBotInventoryActionResponse,
  ApiEnvelopeBotInventoryResponse,
  ApiEnvelopeBotPlayerStateResponse,
  ApiEnvelopeBotResumeConfigResponse,
  ApiEnvelopeBotResumeConfigUpdatedResponse,
  ApiEnvelopeBotStartResponse,
  ApiEnvelopeBotStatusResponse,
  ApiEnvelopeBotStopResponse,
  BotLifecycleGetEntitiesParams,
  ClickBotInventorySlotRequest,
  DropBotInventorySlotRequest,
  MoveBotInventorySlotRequest,
  SendBotCommandRequest,
  SetBotResumeConfigRequest,
  StartBotRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type botLifecycleStartBotResponse200 = {
  data: ApiEnvelopeBotStartResponse
  status: 200
}

export type botLifecycleStartBotResponse400 = {
  data: ApiEnvelopeBotStartResponse
  status: 400
}

export type botLifecycleStartBotResponse401 = {
  data: ApiEnvelopeBotStartResponse
  status: 401
}

export type botLifecycleStartBotResponse403 = {
  data: ApiEnvelopeBotStartResponse
  status: 403
}

export type botLifecycleStartBotResponse404 = {
  data: ApiEnvelopeBotStartResponse
  status: 404
}

export type botLifecycleStartBotResponseSuccess = (botLifecycleStartBotResponse200) & {
  headers: Headers;
};
export type botLifecycleStartBotResponseError = (botLifecycleStartBotResponse400 | botLifecycleStartBotResponse401 | botLifecycleStartBotResponse403 | botLifecycleStartBotResponse404) & {
  headers: Headers;
};

export type botLifecycleStartBotResponse = (botLifecycleStartBotResponseSuccess | botLifecycleStartBotResponseError)

export const getBotLifecycleStartBotUrl = (botId: string,) => {




  return `/api/botengine/${botId}/start`
}

export const useBotLifecycleStartBotHook = (): (botId: string,
    startBotRequest?: StartBotRequest, options?: RequestInit) => Promise<botLifecycleStartBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    startBotRequest?: StartBotRequest, options?: RequestInit) => {

        return customFetcher(getBotLifecycleStartBotUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(startBotRequest)
  }
);
      }
  }


export type botLifecycleGetResumeConfigResponse200 = {
  data: ApiEnvelopeBotResumeConfigResponse
  status: 200
}

export type botLifecycleGetResumeConfigResponse401 = {
  data: ApiEnvelopeBotResumeConfigResponse
  status: 401
}

export type botLifecycleGetResumeConfigResponse403 = {
  data: ApiEnvelopeBotResumeConfigResponse
  status: 403
}

export type botLifecycleGetResumeConfigResponse404 = {
  data: ApiEnvelopeBotResumeConfigResponse
  status: 404
}

export type botLifecycleGetResumeConfigResponseSuccess = (botLifecycleGetResumeConfigResponse200) & {
  headers: Headers;
};
export type botLifecycleGetResumeConfigResponseError = (botLifecycleGetResumeConfigResponse401 | botLifecycleGetResumeConfigResponse403 | botLifecycleGetResumeConfigResponse404) & {
  headers: Headers;
};

export type botLifecycleGetResumeConfigResponse = (botLifecycleGetResumeConfigResponseSuccess | botLifecycleGetResumeConfigResponseError)

export const getBotLifecycleGetResumeConfigUrl = (botId: string,) => {




  return `/api/botengine/${botId}/resume-config`
}

export const useBotLifecycleGetResumeConfigHook = (): (botId: string, options?: RequestInit) => Promise<botLifecycleGetResumeConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotLifecycleGetResumeConfigUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botLifecycleSetResumeConfigResponse200 = {
  data: ApiEnvelopeBotResumeConfigUpdatedResponse
  status: 200
}

export type botLifecycleSetResumeConfigResponse400 = {
  data: ApiEnvelopeBotResumeConfigUpdatedResponse
  status: 400
}

export type botLifecycleSetResumeConfigResponse401 = {
  data: ApiEnvelopeBotResumeConfigUpdatedResponse
  status: 401
}

export type botLifecycleSetResumeConfigResponse403 = {
  data: ApiEnvelopeBotResumeConfigUpdatedResponse
  status: 403
}

export type botLifecycleSetResumeConfigResponse404 = {
  data: ApiEnvelopeBotResumeConfigUpdatedResponse
  status: 404
}

export type botLifecycleSetResumeConfigResponseSuccess = (botLifecycleSetResumeConfigResponse200) & {
  headers: Headers;
};
export type botLifecycleSetResumeConfigResponseError = (botLifecycleSetResumeConfigResponse400 | botLifecycleSetResumeConfigResponse401 | botLifecycleSetResumeConfigResponse403 | botLifecycleSetResumeConfigResponse404) & {
  headers: Headers;
};

export type botLifecycleSetResumeConfigResponse = (botLifecycleSetResumeConfigResponseSuccess | botLifecycleSetResumeConfigResponseError)

export const getBotLifecycleSetResumeConfigUrl = (botId: string,) => {




  return `/api/botengine/${botId}/resume-config`
}

export const useBotLifecycleSetResumeConfigHook = (): (botId: string,
    setBotResumeConfigRequest?: SetBotResumeConfigRequest, options?: RequestInit) => Promise<botLifecycleSetResumeConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    setBotResumeConfigRequest?: SetBotResumeConfigRequest, options?: RequestInit) => {

        return customFetcher(getBotLifecycleSetResumeConfigUrl(botId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setBotResumeConfigRequest)
  }
);
      }
  }


export type botLifecycleStopBotResponse200 = {
  data: ApiEnvelopeBotStopResponse
  status: 200
}

export type botLifecycleStopBotResponse401 = {
  data: ApiEnvelopeBotStopResponse
  status: 401
}

export type botLifecycleStopBotResponse403 = {
  data: ApiEnvelopeBotStopResponse
  status: 403
}

export type botLifecycleStopBotResponse404 = {
  data: ApiEnvelopeBotStopResponse
  status: 404
}

export type botLifecycleStopBotResponseSuccess = (botLifecycleStopBotResponse200) & {
  headers: Headers;
};
export type botLifecycleStopBotResponseError = (botLifecycleStopBotResponse401 | botLifecycleStopBotResponse403 | botLifecycleStopBotResponse404) & {
  headers: Headers;
};

export type botLifecycleStopBotResponse = (botLifecycleStopBotResponseSuccess | botLifecycleStopBotResponseError)

export const getBotLifecycleStopBotUrl = (botId: string,) => {




  return `/api/botengine/${botId}/stop`
}

export const useBotLifecycleStopBotHook = (): (botId: string, options?: RequestInit) => Promise<botLifecycleStopBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotLifecycleStopBotUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type botLifecycleRestartBotResponse200 = {
  data: ApiEnvelopeBotStartResponse
  status: 200
}

export type botLifecycleRestartBotResponse400 = {
  data: ApiEnvelopeBotStartResponse
  status: 400
}

export type botLifecycleRestartBotResponse401 = {
  data: ApiEnvelopeBotStartResponse
  status: 401
}

export type botLifecycleRestartBotResponse403 = {
  data: ApiEnvelopeBotStartResponse
  status: 403
}

export type botLifecycleRestartBotResponse404 = {
  data: ApiEnvelopeBotStartResponse
  status: 404
}

export type botLifecycleRestartBotResponseSuccess = (botLifecycleRestartBotResponse200) & {
  headers: Headers;
};
export type botLifecycleRestartBotResponseError = (botLifecycleRestartBotResponse400 | botLifecycleRestartBotResponse401 | botLifecycleRestartBotResponse403 | botLifecycleRestartBotResponse404) & {
  headers: Headers;
};

export type botLifecycleRestartBotResponse = (botLifecycleRestartBotResponseSuccess | botLifecycleRestartBotResponseError)

export const getBotLifecycleRestartBotUrl = (botId: string,) => {




  return `/api/botengine/${botId}/restart`
}

export const useBotLifecycleRestartBotHook = (): (botId: string, options?: RequestInit) => Promise<botLifecycleRestartBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotLifecycleRestartBotUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type botLifecycleSendCommandResponse200 = {
  data: ApiEnvelopeBotCommandResponse
  status: 200
}

export type botLifecycleSendCommandResponse400 = {
  data: ApiEnvelopeBotCommandResponse
  status: 400
}

export type botLifecycleSendCommandResponse401 = {
  data: ApiEnvelopeBotCommandResponse
  status: 401
}

export type botLifecycleSendCommandResponse403 = {
  data: ApiEnvelopeBotCommandResponse
  status: 403
}

export type botLifecycleSendCommandResponse404 = {
  data: ApiEnvelopeBotCommandResponse
  status: 404
}

export type botLifecycleSendCommandResponseSuccess = (botLifecycleSendCommandResponse200) & {
  headers: Headers;
};
export type botLifecycleSendCommandResponseError = (botLifecycleSendCommandResponse400 | botLifecycleSendCommandResponse401 | botLifecycleSendCommandResponse403 | botLifecycleSendCommandResponse404) & {
  headers: Headers;
};

export type botLifecycleSendCommandResponse = (botLifecycleSendCommandResponseSuccess | botLifecycleSendCommandResponseError)

export const getBotLifecycleSendCommandUrl = (botId: string,) => {




  return `/api/botengine/${botId}/command`
}

export const useBotLifecycleSendCommandHook = (): (botId: string,
    sendBotCommandRequest?: SendBotCommandRequest, options?: RequestInit) => Promise<botLifecycleSendCommandResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sendBotCommandRequest?: SendBotCommandRequest, options?: RequestInit) => {

        return customFetcher(getBotLifecycleSendCommandUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sendBotCommandRequest)
  }
);
      }
  }


export type botLifecycleGetStatusResponse200 = {
  data: ApiEnvelopeBotStatusResponse
  status: 200
}

export type botLifecycleGetStatusResponse401 = {
  data: ApiEnvelopeBotStatusResponse
  status: 401
}

export type botLifecycleGetStatusResponse403 = {
  data: ApiEnvelopeBotStatusResponse
  status: 403
}

export type botLifecycleGetStatusResponse404 = {
  data: ApiEnvelopeBotStatusResponse
  status: 404
}

export type botLifecycleGetStatusResponseSuccess = (botLifecycleGetStatusResponse200) & {
  headers: Headers;
};
export type botLifecycleGetStatusResponseError = (botLifecycleGetStatusResponse401 | botLifecycleGetStatusResponse403 | botLifecycleGetStatusResponse404) & {
  headers: Headers;
};

export type botLifecycleGetStatusResponse = (botLifecycleGetStatusResponseSuccess | botLifecycleGetStatusResponseError)

export const getBotLifecycleGetStatusUrl = (botId: string,) => {




  return `/api/botengine/${botId}/status`
}

export const useBotLifecycleGetStatusHook = (): (botId: string, options?: RequestInit) => Promise<botLifecycleGetStatusResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotLifecycleGetStatusUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botLifecycleGetChatLogResponse200 = {
  data: ApiEnvelopeBotChatLogResponse
  status: 200
}

export type botLifecycleGetChatLogResponse401 = {
  data: ApiEnvelopeBotChatLogResponse
  status: 401
}

export type botLifecycleGetChatLogResponse403 = {
  data: ApiEnvelopeBotChatLogResponse
  status: 403
}

export type botLifecycleGetChatLogResponse404 = {
  data: ApiEnvelopeBotChatLogResponse
  status: 404
}

export type botLifecycleGetChatLogResponseSuccess = (botLifecycleGetChatLogResponse200) & {
  headers: Headers;
};
export type botLifecycleGetChatLogResponseError = (botLifecycleGetChatLogResponse401 | botLifecycleGetChatLogResponse403 | botLifecycleGetChatLogResponse404) & {
  headers: Headers;
};

export type botLifecycleGetChatLogResponse = (botLifecycleGetChatLogResponseSuccess | botLifecycleGetChatLogResponseError)

export const getBotLifecycleGetChatLogUrl = (botId: string,) => {




  return `/api/botengine/${botId}/chatlog`
}

export const useBotLifecycleGetChatLogHook = (): (botId: string, options?: RequestInit) => Promise<botLifecycleGetChatLogResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotLifecycleGetChatLogUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botLifecycleGetConsoleLogResponse200 = {
  data: ApiEnvelopeBotConsoleLogResponse
  status: 200
}

export type botLifecycleGetConsoleLogResponse401 = {
  data: ApiEnvelopeBotConsoleLogResponse
  status: 401
}

export type botLifecycleGetConsoleLogResponse403 = {
  data: ApiEnvelopeBotConsoleLogResponse
  status: 403
}

export type botLifecycleGetConsoleLogResponse404 = {
  data: ApiEnvelopeBotConsoleLogResponse
  status: 404
}

export type botLifecycleGetConsoleLogResponseSuccess = (botLifecycleGetConsoleLogResponse200) & {
  headers: Headers;
};
export type botLifecycleGetConsoleLogResponseError = (botLifecycleGetConsoleLogResponse401 | botLifecycleGetConsoleLogResponse403 | botLifecycleGetConsoleLogResponse404) & {
  headers: Headers;
};

export type botLifecycleGetConsoleLogResponse = (botLifecycleGetConsoleLogResponseSuccess | botLifecycleGetConsoleLogResponseError)

export const getBotLifecycleGetConsoleLogUrl = (botId: string,) => {




  return `/api/botengine/${botId}/consolelog`
}

export const useBotLifecycleGetConsoleLogHook = (): (botId: string, options?: RequestInit) => Promise<botLifecycleGetConsoleLogResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotLifecycleGetConsoleLogUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botLifecycleGetPlayerStateResponse200 = {
  data: ApiEnvelopeBotPlayerStateResponse
  status: 200
}

export type botLifecycleGetPlayerStateResponse401 = {
  data: ApiEnvelopeBotPlayerStateResponse
  status: 401
}

export type botLifecycleGetPlayerStateResponse403 = {
  data: ApiEnvelopeBotPlayerStateResponse
  status: 403
}

export type botLifecycleGetPlayerStateResponse404 = {
  data: ApiEnvelopeBotPlayerStateResponse
  status: 404
}

export type botLifecycleGetPlayerStateResponseSuccess = (botLifecycleGetPlayerStateResponse200) & {
  headers: Headers;
};
export type botLifecycleGetPlayerStateResponseError = (botLifecycleGetPlayerStateResponse401 | botLifecycleGetPlayerStateResponse403 | botLifecycleGetPlayerStateResponse404) & {
  headers: Headers;
};

export type botLifecycleGetPlayerStateResponse = (botLifecycleGetPlayerStateResponseSuccess | botLifecycleGetPlayerStateResponseError)

export const getBotLifecycleGetPlayerStateUrl = (botId: string,) => {




  return `/api/botengine/${botId}/playerstate`
}

export const useBotLifecycleGetPlayerStateHook = (): (botId: string, options?: RequestInit) => Promise<botLifecycleGetPlayerStateResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotLifecycleGetPlayerStateUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botLifecycleGetInventoryResponse200 = {
  data: ApiEnvelopeBotInventoryResponse
  status: 200
}

export type botLifecycleGetInventoryResponse401 = {
  data: ApiEnvelopeBotInventoryResponse
  status: 401
}

export type botLifecycleGetInventoryResponse403 = {
  data: ApiEnvelopeBotInventoryResponse
  status: 403
}

export type botLifecycleGetInventoryResponse404 = {
  data: ApiEnvelopeBotInventoryResponse
  status: 404
}

export type botLifecycleGetInventoryResponseSuccess = (botLifecycleGetInventoryResponse200) & {
  headers: Headers;
};
export type botLifecycleGetInventoryResponseError = (botLifecycleGetInventoryResponse401 | botLifecycleGetInventoryResponse403 | botLifecycleGetInventoryResponse404) & {
  headers: Headers;
};

export type botLifecycleGetInventoryResponse = (botLifecycleGetInventoryResponseSuccess | botLifecycleGetInventoryResponseError)

export const getBotLifecycleGetInventoryUrl = (botId: string,) => {




  return `/api/botengine/${botId}/inventory`
}

export const useBotLifecycleGetInventoryHook = (): (botId: string, options?: RequestInit) => Promise<botLifecycleGetInventoryResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotLifecycleGetInventoryUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botLifecycleGetEntitiesResponse200 = {
  data: ApiEnvelopeBotEntitiesResponse
  status: 200
}

export type botLifecycleGetEntitiesResponse401 = {
  data: ApiEnvelopeBotEntitiesResponse
  status: 401
}

export type botLifecycleGetEntitiesResponse403 = {
  data: ApiEnvelopeBotEntitiesResponse
  status: 403
}

export type botLifecycleGetEntitiesResponse404 = {
  data: ApiEnvelopeBotEntitiesResponse
  status: 404
}

export type botLifecycleGetEntitiesResponseSuccess = (botLifecycleGetEntitiesResponse200) & {
  headers: Headers;
};
export type botLifecycleGetEntitiesResponseError = (botLifecycleGetEntitiesResponse401 | botLifecycleGetEntitiesResponse403 | botLifecycleGetEntitiesResponse404) & {
  headers: Headers;
};

export type botLifecycleGetEntitiesResponse = (botLifecycleGetEntitiesResponseSuccess | botLifecycleGetEntitiesResponseError)

export const getBotLifecycleGetEntitiesUrl = (botId: string,
    params?: BotLifecycleGetEntitiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/botengine/${botId}/entities?${stringifiedParams}` : `/api/botengine/${botId}/entities`
}

export const useBotLifecycleGetEntitiesHook = (): (botId: string,
    params?: BotLifecycleGetEntitiesParams, options?: RequestInit) => Promise<botLifecycleGetEntitiesResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    params?: BotLifecycleGetEntitiesParams, options?: RequestInit) => {

        return customFetcher(getBotLifecycleGetEntitiesUrl(botId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botLifecycleDropInventorySlotResponse200 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 200
}

export type botLifecycleDropInventorySlotResponse400 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 400
}

export type botLifecycleDropInventorySlotResponse401 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 401
}

export type botLifecycleDropInventorySlotResponse403 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 403
}

export type botLifecycleDropInventorySlotResponse404 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 404
}

export type botLifecycleDropInventorySlotResponseSuccess = (botLifecycleDropInventorySlotResponse200) & {
  headers: Headers;
};
export type botLifecycleDropInventorySlotResponseError = (botLifecycleDropInventorySlotResponse400 | botLifecycleDropInventorySlotResponse401 | botLifecycleDropInventorySlotResponse403 | botLifecycleDropInventorySlotResponse404) & {
  headers: Headers;
};

export type botLifecycleDropInventorySlotResponse = (botLifecycleDropInventorySlotResponseSuccess | botLifecycleDropInventorySlotResponseError)

export const getBotLifecycleDropInventorySlotUrl = (botId: string,) => {




  return `/api/botengine/${botId}/inventory/drop`
}

export const useBotLifecycleDropInventorySlotHook = (): (botId: string,
    dropBotInventorySlotRequest?: DropBotInventorySlotRequest, options?: RequestInit) => Promise<botLifecycleDropInventorySlotResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    dropBotInventorySlotRequest?: DropBotInventorySlotRequest, options?: RequestInit) => {

        return customFetcher(getBotLifecycleDropInventorySlotUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(dropBotInventorySlotRequest)
  }
);
      }
  }


export type botLifecycleCloseInventoryWindowResponse200 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 200
}

export type botLifecycleCloseInventoryWindowResponse400 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 400
}

export type botLifecycleCloseInventoryWindowResponse401 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 401
}

export type botLifecycleCloseInventoryWindowResponse403 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 403
}

export type botLifecycleCloseInventoryWindowResponse404 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 404
}

export type botLifecycleCloseInventoryWindowResponseSuccess = (botLifecycleCloseInventoryWindowResponse200) & {
  headers: Headers;
};
export type botLifecycleCloseInventoryWindowResponseError = (botLifecycleCloseInventoryWindowResponse400 | botLifecycleCloseInventoryWindowResponse401 | botLifecycleCloseInventoryWindowResponse403 | botLifecycleCloseInventoryWindowResponse404) & {
  headers: Headers;
};

export type botLifecycleCloseInventoryWindowResponse = (botLifecycleCloseInventoryWindowResponseSuccess | botLifecycleCloseInventoryWindowResponseError)

export const getBotLifecycleCloseInventoryWindowUrl = (botId: string,) => {




  return `/api/botengine/${botId}/inventory/close`
}

export const useBotLifecycleCloseInventoryWindowHook = (): (botId: string, options?: RequestInit) => Promise<botLifecycleCloseInventoryWindowResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotLifecycleCloseInventoryWindowUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type botLifecycleMoveInventorySlotResponse200 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 200
}

export type botLifecycleMoveInventorySlotResponse400 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 400
}

export type botLifecycleMoveInventorySlotResponse401 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 401
}

export type botLifecycleMoveInventorySlotResponse403 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 403
}

export type botLifecycleMoveInventorySlotResponse404 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 404
}

export type botLifecycleMoveInventorySlotResponseSuccess = (botLifecycleMoveInventorySlotResponse200) & {
  headers: Headers;
};
export type botLifecycleMoveInventorySlotResponseError = (botLifecycleMoveInventorySlotResponse400 | botLifecycleMoveInventorySlotResponse401 | botLifecycleMoveInventorySlotResponse403 | botLifecycleMoveInventorySlotResponse404) & {
  headers: Headers;
};

export type botLifecycleMoveInventorySlotResponse = (botLifecycleMoveInventorySlotResponseSuccess | botLifecycleMoveInventorySlotResponseError)

export const getBotLifecycleMoveInventorySlotUrl = (botId: string,) => {




  return `/api/botengine/${botId}/inventory/move`
}

export const useBotLifecycleMoveInventorySlotHook = (): (botId: string,
    moveBotInventorySlotRequest?: MoveBotInventorySlotRequest, options?: RequestInit) => Promise<botLifecycleMoveInventorySlotResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    moveBotInventorySlotRequest?: MoveBotInventorySlotRequest, options?: RequestInit) => {

        return customFetcher(getBotLifecycleMoveInventorySlotUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(moveBotInventorySlotRequest)
  }
);
      }
  }


export type botLifecycleClickInventorySlotResponse200 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 200
}

export type botLifecycleClickInventorySlotResponse400 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 400
}

export type botLifecycleClickInventorySlotResponse401 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 401
}

export type botLifecycleClickInventorySlotResponse403 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 403
}

export type botLifecycleClickInventorySlotResponse404 = {
  data: ApiEnvelopeBotInventoryActionResponse
  status: 404
}

export type botLifecycleClickInventorySlotResponseSuccess = (botLifecycleClickInventorySlotResponse200) & {
  headers: Headers;
};
export type botLifecycleClickInventorySlotResponseError = (botLifecycleClickInventorySlotResponse400 | botLifecycleClickInventorySlotResponse401 | botLifecycleClickInventorySlotResponse403 | botLifecycleClickInventorySlotResponse404) & {
  headers: Headers;
};

export type botLifecycleClickInventorySlotResponse = (botLifecycleClickInventorySlotResponseSuccess | botLifecycleClickInventorySlotResponseError)

export const getBotLifecycleClickInventorySlotUrl = (botId: string,) => {




  return `/api/botengine/${botId}/inventory/click`
}

export const useBotLifecycleClickInventorySlotHook = (): (botId: string,
    clickBotInventorySlotRequest?: ClickBotInventorySlotRequest, options?: RequestInit) => Promise<botLifecycleClickInventorySlotResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    clickBotInventorySlotRequest?: ClickBotInventorySlotRequest, options?: RequestInit) => {

        return customFetcher(getBotLifecycleClickInventorySlotUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(clickBotInventorySlotRequest)
  }
);
      }
  }


